module.exports = __webpack_public_path__ + "static/media/image_corn_layout.030bd1a7.png";